export default "__VITE_ASSET__vn1UeDaz__"